import { useContext } from 'react';
import ConversationsContext, {
  ConversationsContextType,
} from './ConversationsContextStore';

const useConversations = (): ConversationsContextType => {
  const context = useContext(ConversationsContext);
  if (!context) {
    throw new Error('useConversations must be used within a ConversationsProvider');
  }
  return context;
};

export default useConversations;
